import { FC } from "react";

import { Typography } from "antd";

import { 
    ResponsiveContainer, 
    CartesianGrid, 
    XAxis, 
    YAxis,
    Bar, 
    BarChart as AntdBarChart, 
    Legend, 
    Tooltip, 
} from "recharts";
import { CategoricalChartProps } from "recharts/types/chart/generateCategoricalChart";
import { Props as ResponsiveContainerProps } from "recharts/types/component/ResponsiveContainer";
import { Props as CartesianGridProps } from "recharts/types/cartesian/CartesianGrid";
import { BarProps } from "recharts/types/cartesian/Bar";

import { COLORS } from "../../../../../config/themes/colors";
import { ColSize } from "../../../ColSize";
import { CustomLegend, CustomLegendProps, CustomTooltip } from "..";

import './index.css';

interface BarChartProps extends CategoricalChartProps {
    barProps:                   BarProps;
    cartesianGridProps?:        CartesianGridProps;
    responsiveContainerProps?:  ResponsiveContainerProps;
    legendProps?:               CustomLegendProps;
    subTitle?:                  string;
    title?:                     string;
    xDataKey:                   string;
}

export const BarChart: FC<BarChartProps> = ({ 
    barProps,
    cartesianGridProps = {},
    data,
    maxBarSize = 50, 
    responsiveContainerProps = {},
    subTitle,
    title,
    xDataKey,
    legendProps = {},
}) => (
    <div className="bar-chart-container">
        {
            title || subTitle
            ? (
                <ColSize size={100} className="bar-chart-container-title">
                    <Typography.Title level={ 4 } className="bar-chart-title"> { title } </Typography.Title>
                    <Typography.Text type="secondary"> { subTitle } </Typography.Text>
                </ColSize>
            )
            : <></>
        }

        {
            data
            ? (
                <ColSize size={100} > 
                    <ResponsiveContainer width="97.3%" height={600} {...responsiveContainerProps } >
                        <AntdBarChart data={data} maxBarSize={maxBarSize}>
                            <Legend 
                                content={ <CustomLegend { ...legendProps } /> } 
                                align='left' 
                                verticalAlign='top'
                            />

                            <CartesianGrid stroke="#f5f5f5" { ...cartesianGridProps } />

                            <Tooltip 
                                content={
                                    ( props ) => <CustomTooltip label={ legendProps?.label ?? '' } hoveredElement={props.payload} />
                                } 
                                cursor={{ fillOpacity: 0.4 }}  
                            />

                            <XAxis dataKey={xDataKey} />

                            <YAxis strokeWidth={0} />

                            <Bar
                                alignmentBaseline="central" 
                                fill={COLORS.primary[50]}
                                radius={5}
                                { ...barProps }    
                            />
                        </AntdBarChart>
                    </ResponsiveContainer>
                </ColSize>
            )
            : <></>
        }
        
        
    </div>
)
